// GlobalModal.js
import React from 'react';
import { useModal } from '../helpers/ModalContext';
import { X } from 'lucide-react';
import Logo from '../assets/logo2.png'
export default function GameModal() {
    const { isOpen, game, closeModal } = useModal();

    if (!isOpen || !game) return null;

    return (
        <div className="global-modal">
            <div className='p-2' >
                <img src={Logo} width={70}/>
                <button className="btn btn-primary"  style={{float:'right'}}
                onClick={closeModal}>Close <X size={22} /></button>
            </div>
            <iframe
                src={game.Content}
                title={game.Title}
                style={{ width: '100%', height: '100%', border: 'none' }}
            />
        </div>
    );
}
